export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/daily-cash-summary/:pageId',
        component: () => import('@/views/page/company/core-accounting/summary/DailyCashSummary.vue'),
        name: 'daily-cash-summary',
        meta: {
            requiresAuth: true
        }
    },
]